import React, { useEffect, useState } from "react";
import jsVectorMap from "jsvectormap";
import "jsvectormap/dist/maps/world.js";
import axios from "axios";
import { BaseUrl } from "../../helper/apiHelper";
import toast from "react-hot-toast";
const TopCountries = ({ topCountryStates }) => {
//   const [dashboardData, setDashboardData] = useState();
//   const [topCountryStates, setTopCountryStates] = useState();

  useEffect(() => {
    const map = new jsVectorMap({
      selector: "#map",
      map: "world",
      backgroundColor: "transparent",
      regionStyle: {
        initial: { fill: "#D1D5DB" },
      },
      markerStyle: {
        initial: {
          r: 5,
          fill: "#fff",
          "fill-opacity": 1,
          stroke: "#000",
          "stroke-width": 1,
          "stroke-opacity": 0.4,
        },
      },
      markers: [
        { coords: [35.8617, 104.1954], name: "China" },
        { coords: [56.1304, -106.3468], name: "Canada" },
        { coords: [36.77, -119.41], name: "USA" },
        { coords: [20.5937, 78.9629], name: "India" },
      ],
      series: {
        regions: [
          {
            attribute: "fill",
            scale: {
              IN: "#FF9933",
              CA: "	#E76F51",
              CN: "#F3722C",
              US: "#3C3B6E",
            },
            values: {
              IN: "IN",
              CA: "CA",
              CN: "CN",
              US: "US",
            },
          },
        ],
      },
      zoomOnScroll: false,
      enableZoom: false,
      hoverColor: "#fff",
      selectedColor: "#000000",
      hoverOpacity: null,
      normalizeFunction: "linear",
    });

    return () => {
      map && map.destroy();
    };
  }, []);
  let chinaToCanada;
  let chinaToIndia;
  let indiaToCanada;
  let indiaToUsa;
  let chinaToCanadaCount;
  let chinaToIndiaCount;
  let indiaToCanadaCount;
  let indiaToUsaCount;
  if (topCountryStates) {
    ({
      chinaToCanada,
      chinaToIndia,
      indiaToCanada,
      indiaToUsa,
      chinaToCanadaCount,
      chinaToIndiaCount,
      indiaToCanadaCount,
      indiaToUsaCount,
    } = topCountryStates);
  }

  return (
    <div className="col-xxl-6 col-xl-12">
      <div className="card h-100">
        <div className="card-body">
          <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between mb-20">
            <h6 className="mb-2 fw-bold text-lg mb-0">Top Countries</h6>
          </div>
          <div className="row gy-4">
            <div className="col-lg-6">
              <div id="map" className="h-100 border radius-8"></div>
            </div>
            <div className="col-lg-6">
              <div className="h-100 border p-16 pe-0 radius-8">
                <div className="max-h-266-px overflow-y-auto scroll-sm pe-16">
                  <div className="d-flex align-items-center justify-content-between gap-3 mb-12 pb-2">
                    <div className="d-flex align-items-center w-100">
                      <div className="flex-grow-1">
                        <h6 className="text-sm mb-0">China - India</h6>
                        <span className="text-xs text-secondary-light fw-medium">
                          {`${chinaToIndiaCount} orders`}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-2 w-100">
                      <div className="w-100 max-w-66 ms-auto">
                        <div
                          className="progress progress-sm rounded-pill"
                          role="progressbar"
                          aria-label="Success example"
                          aria-valuenow={25}
                          aria-valuemin={0}
                          aria-valuemax={100}
                        >
                          <div
                            className="progress-bar bg-primary-600 rounded-pill"
                            style={{ width: `${chinaToIndia}` }}
                          />
                        </div>
                      </div>
                      <span className="text-secondary-light font-xs fw-semibold">
                        {chinaToIndia}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between gap-3 mb-12 pb-2">
                    <div className="d-flex align-items-center w-100">
                      <div className="flex-grow-1">
                        <h6 className="text-sm mb-0">China - Canada</h6>
                        <span className="text-xs text-secondary-light fw-medium">
                          {`${chinaToCanadaCount} Orders`}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-2 w-100">
                      <div className="w-100 max-w-66 ms-auto">
                        <div
                          className="progress progress-sm rounded-pill"
                          role="progressbar"
                          aria-label="Success example"
                          aria-valuenow={25}
                          aria-valuemin={0}
                          aria-valuemax={100}
                        >
                          <div
                            className="progress-bar bg-orange rounded-pill"
                            style={{ width: `${chinaToCanada}` }}
                          />
                        </div>
                      </div>
                      <span className="text-secondary-light font-xs fw-semibold">
                        {chinaToCanada}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between gap-3 mb-12 pb-2">
                    <div className="d-flex align-items-center w-100">
                      <div className="flex-grow-1">
                        <h6 className="text-sm mb-0">India - Canada</h6>
                        <span className="text-xs text-secondary-light fw-medium">
                          {`${indiaToCanadaCount} Orders`}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-2 w-100">
                      <div className="w-100 max-w-66 ms-auto">
                        <div
                          className="progress progress-sm rounded-pill"
                          role="progressbar"
                          aria-label="Success example"
                          aria-valuenow={25}
                          aria-valuemin={0}
                          aria-valuemax={100}
                        >
                          <div
                            className="progress-bar bg-yellow rounded-pill"
                            style={{ width: `${indiaToCanada}` }}
                          />
                        </div>
                      </div>
                      <span className="text-secondary-light font-xs fw-semibold">
                        {indiaToCanada}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between gap-3 mb-12 pb-2">
                    <div className="d-flex align-items-center w-100">
                      <div className="flex-grow-1">
                        <h6 className="text-sm mb-0">India - USA</h6>
                        <span className="text-xs text-secondary-light fw-medium">
                          {`${indiaToUsaCount} Orders`}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-2 w-100">
                      <div className="w-100 max-w-66 ms-auto">
                        <div
                          className="progress progress-sm rounded-pill"
                          role="progressbar"
                          aria-label="Success example"
                          aria-valuenow={25}
                          aria-valuemin={0}
                          aria-valuemax={100}
                        >
                          <div
                            className="progress-bar bg-success-main rounded-pill"
                            style={{ width: `${indiaToUsa}` }}
                          />
                        </div>
                      </div>
                      <span className="text-secondary-light font-xs fw-semibold">
                        {indiaToUsa}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopCountries;
